import { Component } from '@angular/core';

@Component({
  selector: 'uni-page-content',
  templateUrl: './uni-page-content.component.html',
  styleUrls: ['./uni-page-content.component.scss'],
})
export class UniPageContentComponent { }
